export const dictionary = {
  english: {
    dictionaryTitle: 'Dictionary',
    sggsProject: 'Dictionary',
    subTagLine: 'Lorem Ipsum is simply dummy text of the printing',
    theVision: 'Lorem Ipsum is simply dummy text of the printing',
    visionParagraphOne:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum..',
    visionParagraphTwo:
      'The above is dummy text.',
    visionParagraphThree:
      'Actual text to be shared by Sikhri team.',
  },

  panjabi: {
    dictionaryTitle: 'ਸ਼ਬਦਕੋਸ਼',
    sggsProject: 'ਸ਼ਬਦਕੋਸ਼',
    subTagLine: 'Lorem Ipsum is simply dummy text of the printing',
    theVision: 'Lorem Ipsum is simply dummy text of the printing',
    visionParagraphOne:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    visionParagraphTwo:
      'The above is dummy text.',
    visionParagraphThree:
      'Actual text to be shared by Sikhri team.',
  },
};
